import { render, staticRenderFns } from "./DragDropFile.vue?vue&type=template&id=c849340a&"
import script from "./DragDropFile.vue?vue&type=script&lang=js&"
export * from "./DragDropFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports